export const RESOURCE_SHARE_HASH_PATH = '/api/dashboard/sharing/enable'

export const getCancelSharingPath = (sharingId: string) =>
  `/api/dashboard/sharing/${sharingId}/cancel`

export const getSharingStatusPath = (sharingId: string) =>
  `/api/dashboard/sharing/${sharingId}/status`
